// Module
var code = "<div layout=\"column\"> <h2 class=\"md-display-1 text-center\">Terms Of Use</h2> <div flex ng-include=\"'app/core/modules/root/templates/terms-of-use.tmpl.html'\"></div> </div> ";
// Exports
module.exports = code;